/**
 * Consent promotion handler registry — shared layer (no features import).
 * Wired by ConsentPromotionBridge in features/consent.
 */
import type { CustomerSession } from '../session/CustomerSessionProvider.js';

let promotionHandler: ((session: CustomerSession) => void) | null = null;

export function registerConsentPromotionHandler(
  handler: (session: CustomerSession) => void,
): () => void {
  promotionHandler = handler;
  return () => {
    if (promotionHandler === handler) {
      promotionHandler = null;
    }
  };
}

export function triggerConsentPromotion(session: CustomerSession): void {
  promotionHandler?.(session);
}
